// genreService.js
let genreMap = {};

/**
 * Fetch genres from TMDB API and store globally
 * @param {string} apiKey - your TMDB API key
 */
export async function loadGenres(apiKey) {
    try {
        const res = await fetch(
            `https://api.themoviedb.org/3/genre/movie/list?api_key=${apiKey}&language=en-US`
        );
        const data = await res.json();
        genreMap = data.genres.reduce((acc, genre) => {
            acc[genre.id] = genre.name;
            return acc;
        }, {});
        return genreMap;
    } catch (err) {
        console.error("Failed to load genres");
        return {};
    }
}

/**
 * Get a genre name by ID
 */
export function getGenreName(id) {
    return genreMap[id] || undefined;
}

/**
 * Get all genres
 */
export function getAllGenres() {
    return genreMap;
}
